
import { FETCH_DOSSIER_SUCCESS, FETCH_DOSSIER_FAILURE,REDIRECT_TO_LOGIN } from './actionsTypes';

const initialState = {
  dossierData: [],
  error: null,
  redirectToLoginPage: false,
};

const dossierReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DOSSIER_SUCCESS:
      return {
        ...state,
        dossierData: action.payload.dossierData,
        error: null,
      };
    case FETCH_DOSSIER_FAILURE:
      return {
        ...state,
        dossierData: [],
        error: action.payload.error,
      };
    case REDIRECT_TO_LOGIN:
        return {
            ...state,
            redirectToLoginPage: true,
        };
    default:
      return state;
  }
};

export default dossierReducer;
